import classnames from "classnames"
import moment from "moment"
import { useUIThemeContext } from "../ui/PathwrightUI"
import "./Dateicon.css"

const Dateicon = (props, context) => {
  const theme = useUIThemeContext()
  const color = props.color || theme.primaryBrandColor
  const date = moment(props.date)
  const borderColor = color
  const backgroundColor = color

  if (!date.isValid()) {
    console.warn("invalid date", date)
    return null
  }
  return (
    <div className={classnames("Dateicon", props.className)}>
      <div className="Dateicon__mon" style={{ borderColor, backgroundColor }}>
        {date.format("MMM")}
      </div>
      <div className="Dateicon__day" style={{ borderColor, color }}>
        {date.format("D")}
      </div>
    </div>
  )
}

Dateicon.displayName = "Dateicon"

export default Dateicon
